(function () {
  var RE = /€\s?(\d[\d.,   ]*\d)(\s?EUR)?/g;
  function fix(root) {
    try {
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var n, list = [];
      while ((n = w.nextNode())) {
        var p = n.parentNode;
        if (!p || /^(SCRIPT|STYLE|TEXTAREA|NOSCRIPT)$/.test(p.nodeName)) continue;
        if (n.nodeValue.indexOf('€') !== -1) list.push(n);
      }
      list.forEach(function (t) {
        var v = t.nodeValue.replace(RE, '$1€');
        if (v !== t.nodeValue) t.nodeValue = v;
      });
    } catch (e) {}
  }
  var timer;
  function run() { fix(document.body); }
  function start() {
    run();
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(run, 60);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
